<template>
  <dig-tab class="padding" :items="tabItems" :selectedIndex.sync="selectedTab">
    <div v-if="selectedTab == 0">
      <div style="display:flex;margin-bottom:10px;">
        <div style="margin-right:10px;">Periode:</div>
        <select style="margin-right:10px;" v-model="months.selected">
          <option selected="true" disabled="disabled">Choose</option>
          <option v-for="(month, idx) in months.data" :key="idx">{{month}}</option>
        </select>
        <select style="margin-right:10px;" v-model="years.selected">
          <option v-for="(year, idx) in years.data" :key="idx">{{year}}</option>
        </select>
      </div>
      <div class="loader" v-if="history.isLoading"></div>
      <div style="overflow-x:auto;">
        <table v-if="history.data.length > 0">
          <col style="width:10%">
          <col style="width:35%">
          <col style="width:35%">
          <col style="width:10%">
          <thead>
            <tr><th>Pegawai</th><th style="width:200px;">Payments</th><th style="width:200px;">Reimbursements</th><th>Total</th></tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in history.data" :key="index">
              <td style="text-transform:capitalize;">{{item.name}}</td>
              <td>
                <div style="display:flex;justify-content:space-between;" v-for="(payment, idx) in item.payments" :key="idx">
                  <div style="width:150px;">{{payment.deskripsi}}</div>
                  <div>{{payment.nominal}}</div>
                </div>
              </td>
              <td>
                <div style="display:flex;justify-content:space-between;" v-for="(reimburse, idx) in item.reimbursements" :key="idx">
                  <div style="width:100px;">{{reimburse.deskripsi}}</div>
                  <div>{{reimburse.nominal}}</div>
                </div>
              </td>
              <td class="align-right">{{item.total}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="selectedTab == 1">
      <div>
        <div class="loader" v-if="monthly.data.length == 0 && !monthly.isPaid"></div>
        <div v-if="monthly.isPaid">Monthly Payment has already been paid</div>
        <div v-if="monthly.data.length > 0 && !monthly.isPaid">
          <h2 style="text-align:center;">{{ today }}</h2>
          <div style="overflow-x:auto;">
            <div>
              <table v-if="monthly.data.length > 0">
                <col style="width:10%">
                <col style="width:15%">
                <col style="width:10%">
                <col style="width:50%">
                <thead>
                  <tr><th>Pegawai</th><th>Gaji</th><th>BPJS</th><th style="width:200px;">Reimbursement</th><th>Total</th></tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in monthly.data" :key="index">
                    <td style="text-transform:capitalize;">{{item.name}}</td>
                    <td class="align-right">{{item.gaji}}</td>
                    <td class="align-right">{{item.bpjs}}</td>
                    <td>
                      <div style="display:flex;justify-content:space-between;" v-for="(reimburse, idx) in item.reimburse" :key="idx">
                        <div style="width:75px;">{{reimburse.date}}</div>
                        <div>{{reimburse.tipe}}</div>
                        <div style="width:100px;">{{reimburse.deskripsi}}</div>
                        <div>{{reimburse.nominal}}</div>
                      </div>
                    </td>
                    <td class="align-right">{{ item.total.toLocaleString() }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <dig-button v-if="monthly.data.length > 0 && !monthly.isPaid" @click.native="ProcessPayment" style="margin:10px 0 5px 1px;" type="button-info" text="Pay" :isLoading="monthly.isSubmitting"></dig-button>
        </div>
      </div>
      <dig-notif :text="notif.text" :show.sync="notif.show"></dig-notif>
    </div>
  </dig-tab>
</template>

<script>
import Vue from 'vue'
import Tab from '../digilib_web/vue/tab.vue'
import Form from '../digilib_web/vue/form.vue'
import Table from '../digilib_web/vue/table.vue'
import Notif from '../digilib_web/vue/notif.vue'
import Button from '../digilib_web/vue/button.vue'
import { Http } from '../digilib_web/core/digitify.js'
import moment from 'moment'

export default {
  methods: {
    OnShow: function() {
      Http.Request(
        'GET', 'payments/monthly',
        {
          OnResponse:function(json) {
            if (json) {
              this.monthly.data = json;
            } else {
              this.monthly.isPaid = true;
            }
          }.bind(this)
        }
      );
    },
    OnSearchPayment: function() {
      var payload = {};
      var month = moment(this.months.selected, 'MMM').format('MM');
      payload.period = this.years.selected + '-' + month + '-01';
      this.history.data = [];
      this.history.isLoading = true;
      Http.Request(
        'GET', 'payments/history',
        {
          data: payload,
          OnResponse:function(json) {
            this.history.isLoading = false;
            this.history.data = json;
          }.bind(this)
        }
      );
    },
    ProcessPayment: function() {
      if (this.monthly.isSubmitting) { return; }
      this.monthly.isSubmitting = true;
      Http.Request(
        'POST', 'payments/process',
        {
          data: this.monthly.data,
          OnResponse:function(json) {
            this.monthly.isSubmitting = false;
            if (json.success) {
              this.monthly.isPaid = true;
              this.OnSearchPayment();
            } else {
              alert(json.msg);
            }
          }.bind(this)
        }
      );
    }
  },
  components: {
    'dig-tab': Tab,
    'dig-form': Form,
    'dig-table': Table,
    'dig-notif': Notif,
    'dig-button': Button
  },
  mounted() {
    this.OnShow();
    var today = moment();
    this.today = today.format('MMMM YYYY');
    this.months.data = moment.monthsShort();
    var curYear = today.year();
    this.years.selected = curYear;
    this.years.data.push(curYear);
  },
  data() {
		return {
      selectedTab: 0,
      today: {},
      tabItems: [
        {title:'History', icon:'fa fa-database'},
        {title:'Monthly', icon:'fa fa-plus'}
      ],
      monthly: {
        data:[],
        isSubmitting: false,
        isPaid: false,
      },
      history: {
        data:[],
        isLoading: false,
      },
      notif: {text:'', show:false},
      months: {data: [], selected: ''},
      years: {data: [], selected: ''}
		}
  },
  watch: {
    'months' : {
			handler(n) {
        if (n.selected) {
          this.OnSearchPayment();
        }
			}, deep:true
		}
  }
}
</script>

<style scoped>
</style>
